import React from "react";
import moment from "moment";

import {component_tool} from '@/tool'

import {WizTableForm} from "@/containers/common";

import Info from './components/info'
import Import from './components/import'

const {WizModal} = component_tool

const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})

//配置项
const componentName = 'learningScoreRecord';
const columns = (self) => {
  return [
    {
      title: '年月',
      name: "date",
      searchItem: {
        type: 'month',
        format: 'YYYY-MM',
      },
      tableItem: {
        render: (text) => text && moment(text).format("YYYY年MM月"),
      },
    },
    {
      title: '账号',
      name: "userName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: '姓名',
      name: "fullName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      },
      tableItem: {
        dataIndex: 'orgName',
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "岗位名称",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      },
      tableItem: {
        dataIndex: 'positionName',
      },
    },
    {
      title: "岗位编码",
      name: "positionCode",
      tableItem: {},
    },
    {
      title: "数据类型",
      name: "dataType",
      dict: [
        {code: 0, codeName: '业务积分'},
        {code: 1, codeName: '业务状态'},
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "数据值",
      name: "dataValue",
      tableItem: {
        render: (text, record) => {
          const {dataType, dataValue} = record || {}
          if (dataType === 1) {
            return dataValue > 0 ? '合格' : '不合格'
          }
          return text
        }
      },
    },
    {
      title: "数据来源",
      name: "source",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "备注",
      name: "remark",
      searchItem: {},
      tableItem: {},
    },
  ];
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        // btnAccessCheck: false,
        columns: columns(self),
        searchBarProps: {
          cols: {
            xs: 8,
            md: 8,
            xl: 8
          },
          wrappedComponentRef: self._wizTableList_searchRef,
          dataFormat: (v) => {
            const value = Object.assign({}, v)
            const {date} = value || {}
            value.date = value.date && moment(date).format('YYYY-MM')
            return value
          },
          buttonSort: ['add', 'import', 'export', 'delete'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: {type: 'primary', children: "新增", icon: "plus"},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: 'add',
                  modalParams: {
                    destroyOnClose: true,
                    width: 600,
                    title: "新增",
                    diy: (e) => {
                      const {changeModal} = e
                      return <Info wrappedComponentRef={r => ref_ = r} changeModal={changeModal}/>
                    },
                    onOk: () => {
                      ref_?.submit?.();
                    },
                  },
                },
              },
            },
            {
              key: 'import',
              custom: true,
              params: {icon: 'import', children: '导入销售积分'},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: 'import_score',
                  modalParams: {
                    destroyOnClose: true,
                    width: 600,
                    title: "导入销售积分",
                    diy: (e) => {
                      const {changeModal} = e
                      return <Import type={0} changeModal={changeModal}/>
                    },
                    footer: null
                  },
                },
              },
            },
            {
              key: 'import',
              custom: true,
              params: {icon: 'import', children: '导入售后业务状态'},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: 'import_state',
                  modalParams: {
                    destroyOnClose: true,
                    width: 600,
                    title: "导入售后业务状态",
                    diy: (e) => {
                      const {changeModal} = e
                      return <Import type={1} changeModal={changeModal}/>
                    },
                    footer: null
                  },
                },
              },
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'delete',
              custom: true,
              params: { icon: 'delete', children: '删除', type: 'danger',},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "delete",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  const ids = rows?.map(item => item.id) || {}
                  if (ids?.length < 1){
                    wizNotice.warn("请选择一条数据！");
                    return null
                  }
                  WizModal.confirm({
                    title: '注意',
                    content: '删除后数据不可恢复，您确定要删除选中的数据吗？',
                    onOk: () => {
                      callback && callback({
                        ids: ids,
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                const disabled = !(rows?.length > 0);
                return {
                  disabled: disabled,
                }
              },
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          pageSizeOptions: [
            '10', '20', '40', '100', '200', '500'
          ],
        },
        modalFormProps: {},
        rowOperateProps: {
          // width: 80,
        },
        rowOperateSort: ['update', 'delete'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  destroyOnClose: true,
                  width: 600,
                  title: "编辑",
                  diy: (e) => {
                    const {changeModal, record} = e
                    return <Info wrappedComponentRef={r => ref_ = r} record={record} changeModal={changeModal}/>
                  },
                  onOk: () => {
                    ref_?.submit?.();
                  },
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            }
          },
          {
            key: "delete",
            custom: true,
            params: {children: "删除"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要删除该数据吗？`;
                WizModal.confirm({
                  title: '注意',
                  content,
                  onOk: () => {
                    callback && callback({ids: [record['id']]})
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
        ],
        commonOperate: {}
      }
    }
  };
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {columns, reduxTemplateConfig, templateConfig};
